import React from "react";
import EventCalendar from "../../components/EventCalendar";

function EventCalendarPage() {
  return (
    <div className="md:flex md:justify-center">
      <div className="p-3 md:flex md:flex-row">
        <EventCalendar />
      </div>
    </div>
  );
}

export default EventCalendarPage;
